import { memo } from 'react'
import { useRecoilValue } from 'recoil'
import { userState } from '../../states/user-state'

interface AccountUsersItemProps {
  readonly userId: string
}

const Component = (props: AccountUsersItemProps) => {
  const user = useRecoilValue(userState(props.userId))

  if (!user) return null

  return (
    <tr>
      <td>
        {user?.lastName} {user?.firstName}
      </td>
    </tr>
  )
}

export const AccountUsersItem = memo(Component)